module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4982/img/app-marketplace-network-1x.png"